class CollectionListComponent {
    constructor(collectionListComponent) {
        if (!(collectionListComponent instanceof HTMLElement)) {
            throw new TypeError("The element must be an HTML element.");
        }
        
        this.collectionListComponent = collectionListComponent;
        // get the parent container element (outermost Div in the BE properties view)
        this.collectionComponent = this.collectionListComponent.parentElement;

        // get data from hidden input fields
        this.numberPerPage = this.collectionComponent.querySelector('.num-per-page').value;   
        this.dataSourcePageId = this.collectionComponent.querySelector('.data-source-page-id').value;
        this.developmentPageId = this.collectionComponent.querySelector('.development-page-id').value;
        this.restMessageSuccess = this.collectionComponent.querySelector('.rest-message--success').value;
        this.restMessageFail = this.collectionComponent.querySelector('.rest-message--fail').value;
    }
    init() {
        APIUtils.getComponentData(this.collectionListComponent, 
            `${APIPrefix.get()}/search_api/collection?noOfItemsPerPage=${this.numberPerPage}&dataSourcePageId=${this.dataSourcePageId}&developmentItemId=${this.developmentPageId}`,
            this.restMessageSuccess,
            this.restMessageFail
        ).then( (response) => {
            let propertyData = response.data;
            let propertyTable = new PropertyTable( this.collectionListComponent);
            propertyTable.populateTable(propertyData);
        });
    }
}

// Check for Property List components when the document has loaded and initialise if we have any 
document.addEventListener("DOMContentLoaded", function () {
    const collectionListComponents = document.querySelectorAll('.collection-list-component');
    if (collectionListComponents) {
        collectionListComponents.forEach(function(component) {
            let collectionListComponent = new CollectionListComponent(component);
            collectionListComponent.init();
        });
    }
});